<template>
  <TaskDetailModal :isPossibleAdditional="true" />
</template>

<script>
import TaskDetailModal from '../TaskDetailModal'

export default {
  name: 'AdicionalLikelyModal',
  components: { TaskDetailModal }
}
</script>